module.exports = __webpack_public_path__ + "static/img/powder-coated-aluminum-bulletin-board.4bff5df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/bulletin-boards/powder-coated-aluminum-bulletin-board.jpg
// module id = 708
// module chunks = 0